import FulfilledByIcon from "@redotech/redo-icons/building-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.fulfilledBy;

export const FulfilledByArrayFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  Icon: FulfilledByIcon,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "party",
  itemLabelPlural: "parties",
  values: [...entry.staticValues],
  displayName: entry.displayName,
};
